import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import HomeView from '../pages/Home/Container';
import EnteredView from '../pages/Entered';
import TermsView from '../pages/Terms';
import { Callback } from '../pages/Auth';
import { BASE_PATH } from '../config';

export const ApplicationRoutes = () => {
    return (
        <Routes>
            <Route
                path="*"
                element={
                    <HandleDoubleSlash>
                        <Routes>
                            <Route path={BASE_PATH}>
                                <Route
                                    path=""
                                    element={
                                        <HomeView
                                            OnEntered={
                                                <Navigate to="entered" />
                                            }
                                        />
                                    }
                                />
                                <Route
                                    path="entered"
                                    element={
                                        <EnteredView
                                            OnLoggedOut={<Navigate to="/" />}
                                        />
                                    }
                                />
                                <Route path="terms" element={<TermsView />} />
                                <Route
                                    path="sso/loginuser"
                                    element={<Callback />}
                                />
                            </Route>
                            <Route
                                path="*"
                                element={<Navigate to={BASE_PATH} />}
                            />
                        </Routes>
                    </HandleDoubleSlash>
                }
            />
        </Routes>
    );
};

function HandleDoubleSlash({ children }) {
    /* 
        This is here to handle cases where urls have more than 1 leading /, 
        for example https://super6.skysports.com//league. 
        Without this, you'd get a 404. 
        This caused an issue with silent auth as detailed in https://iw-sbg.atlassian.net/browse/S6-3237 
    */
    const { pathname, search, hash } = useLocation();
    const regex = /\/\/+/g;
    if (pathname.match(regex)) {
        const cleanUrl = `${pathname.replace(regex, '/')}${search}${hash}`;
        return <Navigate to={cleanUrl} />;
    }

    return children;
}

HandleDoubleSlash.propTypes = {
    children: PropTypes.node.isRequired
};

export default ApplicationRoutes;
